import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  DomSanitizer,
  SafeResourceUrl,
  Title,
} from '@angular/platform-browser';
import { environment } from '@perval/shared';
import { Subject, takeUntil } from 'rxjs';
import { ModalService } from '../../../shared/design-system/organisms/p-modal/p-modal.service';
import { BehaviorService } from '../../../shared/services/behavior/behavior.service';
import { Credit } from '../../models/credit';

enum ModalId {
  CGV_MODAL = 'CGV_MODAL',
  PDP_MODAL = 'PDP_MODAL',
}

@Component({
  selector: 'app-informations-administratives',
  templateUrl: './commande-informations-administratives.component.html',
  styleUrls: ['./commande-informations-administratives.component.scss'],
})
export class InformationsAdministrativesComponent implements OnInit, OnDestroy {
  @Input() commande!: Credit.Commande;
  @Input() loading = false;

  @Output() precedent = new EventEmitter<void>();
  @Output() validerCommande = new EventEmitter<Credit.Commande>();

  modalId = ModalId;
  isModalCgvOpen = false;
  isModalPdpOpen = false;
  isCheckboxChecked: boolean = false;

  // TODO : vérifier les urls des CGV et PDP avec le métier.
  cgvUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    `${environment.host}/system/files/new-cga_perval_sur_site_perval.fr_-_majagn20221107.pdf#toolbar=0&navpanes=0&scrollbar=0`,
  );

  pdpUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    `${environment.host}/system/files/dpo-politique_protection_des_donnees_et_gestion_des_cookies_v1.9_-_perva.pdf#toolbar=0&navpanes=0&scrollbar=0`,
  );

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly behaviorService: BehaviorService,
    private readonly modalService: ModalService,
    private readonly sanitizer: DomSanitizer,
    private readonly titleService: Title,
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('Mes informations administratives | Perval.fr');
    this.behaviorService.scrollToTheTop();
    this.modalService
      .getModalState()
      .pipe(takeUntil(this.destroy$))
      .subscribe((modalId) => {
        this.isModalCgvOpen = modalId === ModalId.CGV_MODAL;
        this.isModalPdpOpen = modalId === ModalId.PDP_MODAL;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onPrecedent(): void {
    this.precedent.emit();
  }

  openModal(modalId: ModalId) {
    this.modalService.showModal(modalId);
  }

  onValiderCommande(): void {
    this.validerCommande.emit(this.commande);
  }
}
